import { useMemo } from "react";
import { useAuditEvents } from "@/hooks/useAuditEvents";
import { aggregateGateDefects, type GateDefectsSummary } from "@/lib/gateDefects";

export interface GateDefectsState {
  summary: GateDefectsSummary;
  loading: boolean;
  error: string | null;
  /** Org-wide audit query is plan-gated (403) — not a failure. */
  forbidden: boolean;
}

/**
 * Gate defects caught before merge. Wraps useAuditEvents filtered to
 * gate decisions (the audit stream's governance gate events).
 */
export function useGateDefects(enabled = true): GateDefectsState {
  const { events, loading, error, forbidden } = useAuditEvents(
    { eventKind: "gate_decision" },
    { enabled },
  );
  const summary = useMemo(() => aggregateGateDefects(events), [events]);
  return { summary, loading, error, forbidden };
}
